import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { InstitutionEnumName } from "../../../../enumerations/components/view/InstitutionEnumName";
import { CommissionsSettingsLevelRule } from "../../../level/types";
import { CommissionsSettingsRule } from "../../types";

interface Props {
  rule: CommissionsSettingsRule | CommissionsSettingsLevelRule;
}

export const CommissionsSettingsRuleView = ({ rule }: Props) => {
  const { t } = useTranslation();

  const data = [
    {
      key: "sector",
      content: (
        <span className="nowrap">
          <b>{t("commissions.settings.helpers.sector")}:</b> {t("product.enums.financialSector." + rule.sector)}
        </span>
      ),
    },
    {
      key: "productGroup",
      content: rule.productGroup && (
        <span className="nowrap">
          <b>{t("commissions.settings.helpers.productGroup")}:</b> {rule.productGroup.name}
        </span>
      ),
    },
    {
      key: "institution",
      content: rule.institution && (
        <span className="nowrap">
          <b>{t("commissions.settings.attrs.institutionId")}:</b>{" "}
          <InstitutionEnumName institution={rule.institution} hideDeactivatedLabel />
        </span>
      ),
    },
    {
      key: "product",
      content: rule.product && (
        <span className="nowrap">
          <b>{t("commissions.settings.attrs.productId")}:</b> {rule.product.name}
        </span>
      ),
    },
  ].filter((item) => !!item.content);

  return data.map((item, index) => (
    <Fragment key={item.key}>
      {item.content}
      {index < data.length - 1 && " | "}
    </Fragment>
  ));
};
